export default "/etc.clientlibs/des/cart-checkout/clientlibs/des-cart-checkout/resources/3c053a6bbf9398c1f506716700c2f0ca.png";